export default {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_BUTTONS_HEADER_HEIGHT: 'SET_BUTTONS_HEADER_HEIGHT',
  RESET_BUTTONS_HEADER: 'RESET_BUTTONS_HEADER',
  CHANGE_DOSSIER_SUBTYPE: 'CHANGE_DOSSIER_SUBTYPE',
  APPROVE_MARGIN: 'APPROVE_MARGIN'
}
